let config=window as any;
const URL=config.ipConfigUrl.baseURL
export default URL;